import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.jpg';
import '../styles/main.scss';

class HeaderComponent extends React.Component {
  render() {
    return (
      <nav className="header-nav">
        <div className="header-inner">
          {/* Left curved brand block */}
          <Link to="/" className="brand-link">
            <div className="brand-block">
              <img src={logo} alt="logo" className="brand-logo" />
              <div className="brand-text">
                <div className="brand-title">Parivar Suraksha Foundation</div>
                <div className="brand-sub">Family Protection</div>
              </div>
            </div>
          </Link>
        </div>
      </nav>
    );
  }
}

export default HeaderComponent;
